export const DEFAULT_STALE_TIME_IN_MINUTES = 30

export const ONE_MINUTE_IN_SECONDS = 60

export const ONE_SECOND_IN_MILLISECONDS = 1000

export const DEFAULT_STALE_TIME =
  DEFAULT_STALE_TIME_IN_MINUTES * ONE_MINUTE_IN_SECONDS * ONE_SECOND_IN_MILLISECONDS // 30 minutes
